import React from "react";
import { AiFillMail } from "react-icons/ai";

function Mail({ emailHref, emailLabel }) {
  return (
    <div className="theme-text-muted flex flex-col items-center gap-2 text-sm xs:flex-row md:justify-start">
      <AiFillMail className="theme-text-subtle text-base" />
      <a
        href={emailHref}
        className="theme-link-plain break-all font-medium theme-text-soft"
      >
        {emailLabel}
      </a>
    </div>
  );
}

export default Mail;
